export default "__VITE_ASSET__BPsbfciO__"